import { memo } from 'react'

export const Footer = memo(function Footer() {
  return (
    <footer className="mt-12 rounded-xl border border-border bg-card p-6 text-center text-sm text-muted-foreground">
      <div>© {new Date().getFullYear()} Omni Sight. All rights reserved.</div>
      <div className="mt-2 text-xs opacity-70">Social Media Monitoring Dashboard</div>
    </footer>
  )
})
